import Core, {
  DEFAULT_UI_VERSION
} from '../../lib/Core';
import Google from '../../lib/Google';
import useState from '../../lib/hooks/useState.hook';
import {
  COLLECTION__COMPANY,
  COLLECTION__SCHOOL
} from '../../lib/services/BE/loopback.api';
import {
  getPathname,
  setLocation
} from '../../lib/URL.lib';
import {
  AdminManageTemplatesActionButton
} from '../Admin/TemplatesEditor/ToolBarButton';
import Box from '../Layout/Wrappers/Box';
import Divider from '../Layout/Wrappers/Divider';
import Fieldset from '../Layout/Wrappers/Fieldset';
import Once from '../Layout/Wrappers/Once';
import Paper from '../Layout/Wrappers/Paper';
import StyledRadio from '../Layout/Wrappers/StyledRadio';
import Title from '../Layout/Wrappers/Title';
import {
  Label
} from '../Layout/Wrappers/Typography';
import AccordionCandidateHistoryEntities from './AccordionCandidateHistoryEntities';
import AccordionGSuite from './AccordionGSuite';
import SampleJsonData from './SampleJsonData';

export default function AdminTools() {
  const [state, updateState] = useState({
    expanded: COLLECTION__COMPANY
  });

  const onChangeExpanded = (componentKey) => (event, expanded) => {
    updateState({ expanded: expanded ? componentKey : false });
  };

  return (
    <Paper
      className='mb-1 mx-auto'
      style={{
        maxWidth: 'calc(100vw - 2rem)',
      }}
    >
      <Once
        promise={async () => {
          if (Core.isAdminOrCoordinator()) {
            updateState({ isConnected: await Google.isConnected() });
          }
        }}
      />

      <Box className='bg-white-common sticky-top'>
        <Box className='p-2'>
          <Title className='c-purple'>
            Admin tools
          </Title>
        </Box>
        <Divider />
      </Box>


      <Box column
        className='p-2'
      >

        <Box row className='flex-align-left-top flex-wrap'>

          <Box column flex1
            className='mr-1'
            style={{ maxWidth: 512 }}
          >

            <AccordionGSuite />

            <Fieldset title='Email automation'>
              <AdminManageTemplatesActionButton />
            </Fieldset>

            <SampleJsonData />

            <Fieldset
              acl={Core.isAdmin()}
              title={
                <Label className='tt-none'>
                  UI version
                </Label>
              }
            >
              <StyledRadio
                options={[
                  { id: 1, label: 'v1' },
                  { id: 3, label: 'v3' }
                ]}
                defaultValue={DEFAULT_UI_VERSION}
                value={+Core.getUIVersion()}
                onChange={(value) => {
                  Core.setUIVersion(value);
                  const pathname = getPathname().replace(/v3\//, '');
                  if (value === 3) {
                    setLocation(Core.getPath(`v3${pathname}`));
                  }
                  else {
                    setLocation(Core.getPath(pathname));
                  }
                }}
              />
            </Fieldset>

          </Box>

          <Box column flex1>

            <AccordionCandidateHistoryEntities
              collection={COLLECTION__COMPANY}
              expanded={state.expanded === COLLECTION__COMPANY}
              onChange={onChangeExpanded(COLLECTION__COMPANY)}
            />

            <AccordionCandidateHistoryEntities
              collection={COLLECTION__SCHOOL}
              expanded={state.expanded === COLLECTION__SCHOOL}
              onChange={onChangeExpanded(COLLECTION__SCHOOL)}
            />

          </Box>

        </Box>

      </Box>

    </Paper>
  );
}
